export default "__VITE_ASSET__652dedd4__"